import { getPlayerSessionId } from "../../helpers";

async function sendSwitchRoomRequest(roomToGo: string): Promise<boolean> {
    try {
        const response: Response = await fetch(`${viteConfiguration.API_URL}player/room/switch`, {
            method: "post",
            headers: {
                "Content-Type": "application/json",
                "X-PlayerSessionId": getPlayerSessionId(),
            },
            body: JSON.stringify({ roomToGo }),
        });

        const result: any = await response.json();

        console.log(result);

        if (!result) {
            return false;
        }

        return true;
    } catch (error) {
        console.error(error);
    }
    return false;
}

export default sendSwitchRoomRequest;
